import { render, staticRenderFns } from "./Voicemail.vue?vue&type=template&id=701ca705&"
import script from "./Voicemail.vue?vue&type=script&lang=js&"
export * from "./Voicemail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports